import { cn } from "@/lib/utils";

const MAP = {
  // generic
  active: "success", open: "info", draft: "neutral", done: "success",
  todo: "neutral", in_progress: "info", blocked: "danger", archived: "neutral",
  closed_won: "success", closed_lost: "danger", paused: "warning",
  invited: "warning", deactivated: "danger",
  // priority
  low: "neutral", medium: "info", high: "warning", urgent: "danger",
  // relationships
  customer: "info", prospect: "warning", vendor: "success", partner: "brand",
};

const STYLES = {
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  danger: "bg-red-50 text-red-700 border-red-200",
  info: "bg-sky-50 text-sky-700 border-sky-200",
  brand: "bg-blue-50 text-blue-700 border-blue-200",
  neutral: "bg-slate-100 text-slate-600 border-slate-200",
};

export function StatusPill({ value, tone, className }) {
  const key = String(value || "").toLowerCase().replace(/\s+/g, "_");
  const t = tone || MAP[key] || "neutral";
  const label = String(value || "—").replace(/_/g, " ");
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border capitalize",
        STYLES[t], className
      )}
    >
      {label}
    </span>
  );
}
